export function findDeviceById(devices, selectedDeviceId) {
  return devices.find(d => d.deviceId === selectedDeviceId)?.deviceId || devices[0]?.deviceId;
}
